import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    height: "20%",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  control: {
    height: "200px",
  },
}));

export default function Footer() {
  const classes = useStyles();
  var d = new Date();
  var n = d.getFullYear();
  var m = n + 1;

  return (
    <div
      className={classes.container}
      justify="center"
      // style={{ maxWidth: "1100px" }}
    >
      <footer
        className=" pb-5 footer"
        align="center"
        style={{ paddingTop: "50px" }}
      >
        <div className="row" align="center">
          <div className="col-12 col-sm-12 col-md">
            <a href="/" className="navbar-brand">
              <img
                src="image/logo.jpg"
                height="80"
                alt="Icon"
                style={{ borderRadius: "2px" }}
              />
            </a>
            <span className="d-block mb-3 text-muted">
              &copy; {n}-{m}
            </span>
          </div>
          <div className="col-12 col-sm-12 col-md">
            <span
              style={{
                display: "inline-block",
                verticalAlign: "middle",
                lineHeight: "normal",
              }}
            ></span>
            <h2 className="text-white">SOLO TECH</h2>
          </div>
          <div className="col-12 col-sm-12 col-md">
            <h5
              style={{
                display: "inline-block",
                verticalAlign: "middle",
                lineHeight: "normal",
              }}
              className="text-white"
            >
              Contact Us
            </h5>
            <ul className="list-unstyled text-small" color="primary">
              <li>
                <span className="text-white">Email: </span>
                <span className="text-white">solotechfeedback@gmail.com</span>
              </li>
              <li>
                <a
                  className="text-white"
                  href="https://play.google.com/store/apps/details?id=com.solotech.indiadocscanner"
                >
                  Play Store
                </a>
              </li>
              <li>
                <a
                  className="text-white"
                  href="https://instagram.com/bharatdocumentscanner?igshid=tpw0lc0uxh4g"
                >
                  Solo-Tech{" (Instagram) "}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
}
